import React, { useState } from 'react';
import RangeSliderRow from '../parts/RangeSliderRow';
import NitroButton from '../parts/NitroButton';

const Range = ({ qData, pageStyle, nextStep}) => {

  const [allComplete, setAllComplete] = useState(false)
  const [collectResponses, setCollectResponses] = useState([])

  let noUiSliders;

  if (qData.categories.length > 0) {
    noUiSliders = qData.categories.map((category, index) =>
      <RangeSliderRow setCollectResponses={setCollectResponses} setAllComplete={setAllComplete} qData={qData} category={category} rowId={index} key={index} />
    );
  }

  const onSubmit = (data) => {

    const dataToSend = {
      "questionId": qData.id,
      "rangeSliderValue": collectResponses
    }

    nextStep(dataToSend);
  }

  return (
    <>
      <div className="grow py-12">
        <div className="container max-w-lg">

          <div className="flex justify-between text-xs md:text-sm font-black">
            <div>{qData.min.text}</div>
            <div className="text-right ml-4">{qData.max.text}</div>
          </div>

          <div className="w-full">
              {noUiSliders}
          </div>

        </div>
      </div>

      <NitroButton formIsValid={allComplete} label="Next" onClick={onSubmit} />

    </>
  );
}

export default Range;
